import { render, staticRenderFns } from "./ExportReports.vue?vue&type=template&id=5f512e96"
import script from "./ExportReports.vue?vue&type=script&lang=js"
export * from "./ExportReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports